// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"0e4323fa","138":"3e86bc3b","826":"52523b11","861":"c74e45f2"}[chunkId] + ".js";
};